import { IsEmail, IsNotEmpty } from 'class-validator';

import { t } from '@app-velocity/i18n';

export class UserLoginDto {
  @IsEmail(
    {},
    {
      message: t('users:validation.email_is_not_valid'),
    }
  )
  @IsNotEmpty({
    message: t('users:validation.email_cannot_be_empty'),
  })
  email = '';

  @IsNotEmpty({
    message: t('users:validation.password_cannot_be_empty'),
  })
  password = '';
}
